export const version = "bignumber/5.1.0";
//# sourceMappingURL=_version.js.map